/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  active: {
    color: '#4fb385',
  },
  disable: {
    color: theme.palette.error.main,
  },
  invited: {
    color: '#e2a74f',
  },
}));

export default ({ value, onInvitedClick }) => {
  const classes = useStyles();

  const handleInvitedClick = () => {
    if (onInvitedClick) {
      onInvitedClick(value);
    }
  };

  if (value && value.toLowerCase() === 'invited') {
    return (
      <span onClick={handleInvitedClick} style={{ cursor: 'pointer', textDecoration: 'none' }}>
        <Typography variant="body1" className={classes.invited}>
          {value}
        </Typography>
      </span>
    );
  }

  if (value && value.toLowerCase() === 'disabled') {
    return (
      <Typography variant="body1" className={classes.disable}>
        {value}
      </Typography>
    );
  }

  return <Typography className={classes.active}>{value}</Typography>;
};
